module.exports = __webpack_public_path__ + "html/features.component.html";